import { Map } from 'immutable';
import { handleActions } from 'redux-actions';
import * as types from '../constants/actionTypes';

const forgotPasswordReducer = handleActions(
    {
        [`${types.FORGOT_PASSWORD}_FULFILLED`]: (state, action) =>
            state
                .setIn(['loading'], false)
                .setIn(['email'], action.payload.email)
                .setIn(['success'], true),

        [`${types.FORGOT_PASSWORD_FOR_USERNAME}_FULFILLED`]: (state, { payload }) => {
            const isSuccess = payload.valid;

            return state
                .setIn(['loading'], false)
                .setIn(['email'], payload.email)
                .setIn(['success'], isSuccess)
                .setIn(['reason'], payload.reason);
        },
        [`${types.FORGOT_PASSWORD}_PENDING`]: (state) =>
            state.set('loading', true).set('success', false),
        [`${types.FORGOT_PASSWORD}_REJECTED`]: (state) =>
            state.set('loading', false).set('success', false),
        [`${types.FORGOT_PASSWORD_FOR_USERNAME}_PENDING`]: (state) =>
            state.set('loading', true).set('success', false),
        [`${types.FORGOT_PASSWORD_FOR_USERNAME}_REJECTED`]: (state) =>
            state.set('loading', false).set('success', false),
    },
    new Map({ loading: false, success: false }),
);

export default forgotPasswordReducer;
